import {
  ColorOptions,
  Spacer,
  SpacerNew,
  Text,
  TextInputNew,
  TextInputNewProps,
  bankIFSCValidation,
  cardNumber,
} from '@jfs/ui-new'
import { Name, alphaNumericValidation, bankAccountValidation, email, mobileNumber, required } from '@jfs/utils'
import * as Yup from 'yup'
import { AutoCompleteDropdown } from '../../../comps/AutoCompleteDropdown'
import { DropdownOptimised } from '../../../comps/DropdownNew'
import { BeneficiaryDetailsBox } from './BeneficiaryDetailsBox'

export const pincode = Yup.string()
  .trim()
  .required('Required')
  .min(6, 'Please enter 6 digit pincode')
  .matches(/^[0-9]*$/, 'Incorrect pincode')

export const latitudeValidation = Yup.string()
  .matches(/^(-?\d{1,2}(\.\d+)?|-\d{3}(\\.\\d+)?|NA?|(-?)[1-8]\d{0,1}(\.\d+)?)?$/, {
    excludeEmptyString: true,
    message: 'Invalid latitude',
  })
  .nullable()
  .notRequired()

export const longitudeValidation = Yup.string()
  .matches(/^-?((180(.0{1,6})?)|NA?|(((1[0-7]|[1-9])?\d)(\.\d{1,6})?))$/, {
    excludeEmptyString: true,
    message: 'Invalid longitude',
  })
  .nullable()
  .notRequired()

const getAddAddressForm = (isAddPressed: boolean, isEdit: boolean, onAddAddressPressed: any) => {
  return isAddPressed
    ? [
        {
          horizontalComps: [
            {
              fieldName: 'addressLine1',
              ComponentName: TextInputNew,
              label: 'Address Line 1',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'addressLine1',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'addressLine2',
              ComponentName: TextInputNew,
              label: 'Address Line 2',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'addressLine2',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'city',
              ComponentName: TextInputNew,
              label: 'City',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'city',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'stateUt',
              ComponentName: isEdit ? DropdownOptimised : TextInputNew,
              label: 'State/UT',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              editable: isEdit,
              data: isEdit
                ? [
                    { id: '0', value: 'Karnataka' },
                    { id: '1', value: 'Maharashtra' },
                  ]
                : undefined,
              ...styles.textinputStyle(isEdit),
              // ...(isEdit && { dataFieldToRead: 'description' }),
              type: isEdit ? 'default' : 'body12',
              testID: 'stateUt',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'pincode',
              ComponentName: TextInputNew,
              label: 'Pincode',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              maxLength: 6,
              testID: 'pincode',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'addressRole',
              ComponentName: !isEdit ? TextInputNew : DropdownOptimised,
              label: 'Address Role',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              editable: isEdit,
              data: [
                { id: '0', value: 'CRP' },
                { id: '1', value: 'OWN' },
              ],
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'addressRole',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'businessLatitude',
              ComponentName: TextInputNew,
              label: 'Business Latitude',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'businessLatitude',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'businessLongitude',
              ComponentName: TextInputNew,
              label: 'Business Longitude',
              placeholder: '',
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'businessLongitude',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'addressType',
              ComponentName: !isEdit ? TextInputNew : DropdownOptimised,
              label: 'Address Type',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              editable: isEdit,
              data: [
                { id: '0', value: 'BUSINESS' },
                { id: '1', value: 'RESIDENCE' },
              ],
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'default',
              testID: 'addressType',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'landline',
              ComponentName: TextInputNew,
              label: 'Contact number',
              placeholder: '',
              maxLength: 10,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'landline',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
      ]
    : [
        {
          horizontalComps: [
            {
              fieldName: 'addAddressTitle',
              ComponentName: Text,
              fontFamily: 'jiotype-medium',
              color: 'BLUE',
              fontSize: 12,
              testID: 'addAddressTitle',
              onPress: onAddAddressPressed,
              title: '+ Add Address',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'spacer11',
              ComponentName: SpacerNew,
            },
          ],
        },
      ]
}

const getStepOneFormItems = (
  isEdit: boolean,
  step: number,
  data: any,
  isAddAddressPressed: boolean,
  onAddAddressPressed: any,
  showEnteredBeneficiaryBox: boolean,
  onBeneficiaryTypeItemSelected: any,
  beneficiaryTypesList: any[],
) => {
  return step === 1
    ? [
        {
          horizontalComps: [
            {
              fieldName: 'title1',
              ComponentName: Text,
              fontFamily: 'jiotype-bold',
              color: 'BLACK_21',
              fontSize: 16,
              title: 'Add Beneficiary',
              hide: !showEnteredBeneficiaryBox,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'beneficiaryDetails',
              ComponentName: BeneficiaryDetailsBox,
              data: data,
              show: showEnteredBeneficiaryBox,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'title2',
              ComponentName: Text,
              fontFamily: 'jiotype-bold',
              color: 'BLACK_21',
              fontSize: 16,
              title: 'Payment Method',
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'accountNumber',
              ComponentName: TextInputNew,
              label: 'Account Number',
              placeholder: '',
              validationSchema: bankAccountValidation,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'name',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'ifsc',
              ComponentName: TextInputNew,
              label: 'IFSC',
              placeholder: '',
              validationSchema: bankIFSCValidation,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'ifsc',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'upiVpa',
              ComponentName: TextInputNew,
              label: 'UPI VPA',
              placeholder: '',
              validationSchema: required,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'upiVpa',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'cardNumber',
              ComponentName: TextInputNew,
              label: 'Card Number',
              placeholder: '',
              validationSchema: cardNumber,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'cardNumber',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
      ]
    : [
        {
          horizontalComps: [
            {
              fieldName: 'title',
              ComponentName: Text,
              fontFamily: 'jiotype-bold',
              color: 'BLACK_21',
              fontSize: 16,
              title: 'Add Beneficiary',
              hide: !showEnteredBeneficiaryBox,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'name',
              ComponentName: TextInputNew,
              label: 'Name',
              placeholder: '',
              validationSchema: Name,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'name',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'phone',
              ComponentName: TextInputNew,
              label: 'Phone Number',
              placeholder: '',
              validationSchema: mobileNumber,
              maxLength: 10,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'phone',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'email',
              ComponentName: TextInputNew,
              label: 'Email ID',
              placeholder: '',
              validationSchema: email,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'email',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
            {
              fieldName: 'beneficiaryId',
              ComponentName: TextInputNew,
              label: 'Beneficiary ID',
              placeholder: '',
              validationSchema: alphaNumericValidation,
              editable: isEdit,
              ...styles.textinputStyle(isEdit),
              testID: 'phone',
              paddingHorizontal: isEdit ? 8 : undefined,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'beneficiaryType',
              ComponentName: !isEdit ? TextInputNew : AutoCompleteDropdown,
              label: 'Beneficiary Type',
              placeholder: '',
              title: isEdit ? 'Select' : undefined,
              validationSchema: isEdit ? required : undefined,
              editable: isEdit,
              data: beneficiaryTypesList,
              ...(isEdit && { dataFieldToRead: 'description' }),
              ...styles.textinputStyle(isEdit),
              type: !isEdit ? 'body12' : 'DEFAULT',
              testID: 'beneficiaryType',
              onItemSelected: !isEdit ? undefined : onBeneficiaryTypeItemSelected,
            },
            {
              fieldName: 'space1',
              ComponentName: Spacer,
            },
          ],
        },
        ...getAddAddressForm(isAddAddressPressed, isEdit, onAddAddressPressed),
      ]
}

export const formAddSingleBeneficiary: any = (
  isEdit: boolean,
  step: number,
  data: any,
  isAddAddressPressed: boolean,
  onAddAddressPressed: any,
  showEnteredBeneficiaryBox: boolean,
  onBeneficiaryTypeItemSelected: any,
  beneficiaryTypesList: any[],
) => [
  {
    actionTitle: 'Proceed',
    key: 'beneficiaryInfo',
    formItems: [
      ...getStepOneFormItems(
        isEdit,
        step,
        data,
        isAddAddressPressed,
        onAddAddressPressed,
        showEnteredBeneficiaryBox,
        onBeneficiaryTypeItemSelected,
        beneficiaryTypesList,
      ),
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const formEditBeneficiary: any = (
  isEdit: boolean,
  data: any,
  isAddAddressPressed: boolean,
  onAddAddressPressed: any,
  showEnteredBeneficiaryBox: boolean,
  onBeneficiaryTypeItemSelected: any,
  beneficiaryTypesList: any[],
) => [
  {
    actionTitle: 'Proceed',
    key: 'editBeneficiaryInfo',
    formItems: [
      ...getStepOneFormItems(
        isEdit,
        0,
        data,
        isAddAddressPressed,
        onAddAddressPressed,
        showEnteredBeneficiaryBox,
        onBeneficiaryTypeItemSelected,
        beneficiaryTypesList,
      ),
      ...getStepOneFormItems(
        isEdit,
        1,
        data,
        isAddAddressPressed,
        onAddAddressPressed,
        showEnteredBeneficiaryBox,
        onBeneficiaryTypeItemSelected,
        beneficiaryTypesList,
      ),
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

const styles = {
  textinputStyle: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: isEditMode ? ('#d1d3e2' as ColorOptions) : 'WHITE',
      labelPaddingBottom: 10,
      borderRadius: isEditMode ? 4 : 0,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 9,
      padddingHorizontal: 16,
      color: 'BLACK_21' as ColorOptions,
      onFocusBorderWidth: isEditMode ? 1 : 0,
    } as unknown as TextInputNewProps),
}

export const beneficiaryTypesList = [
  { id: '0', text: 'Customer' },
  { id: '1', text: 'Supplier' },
  { id: '2', text: 'Vendor' },
  { id: '3', text: 'Deliver Partner' },
  { id: '4', text: 'Owner' },
]
